import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

import { FakturagodkendelseModalData } from "../model/fakturagodkendelse-modal-data.model";
import { FakturagodkendelseModalComponent } from "./fakturagodkendelse-modal.component";

@Injectable(/*Provides i FakturagodkendelseModule (IKKE i 'root') for at kunne loade FakturagodkendelseModalComponent pga. lazy loading*/)
export class FakturagodkendelseModal {
    constructor(private readonly dialog: MatDialog) {}

    public open(data: FakturagodkendelseModalData): void {
        this.dialog.open(FakturagodkendelseModalComponent, {
            data: { ...data }
        });
    }
}
